import { useQuery } from '@tanstack/react-query';
import { bulkInventoryBinService } from '@/services/propertyBook/BulkInventoryBinService';
import { queryKeys } from '@/lib/queryKeys';
import type { BulkInventoryBinRecord } from '@/services/propertyBook/BulkInventoryBinService';
import { useAuth } from '@/hooks/useAuth';

export const useBulkDisposeRecords = () => {
  const { isAuthenticated } = useAuth();

  return useQuery<BulkInventoryBinRecord[]>({
    queryKey: queryKeys.bulkInventoryBin.pendingDisposal(),
    queryFn: () => bulkInventoryBinService.listPendingDisposal(),
    staleTime: 30_000,
    enabled: isAuthenticated,
  });
};
